import React from 'react';

type InfoFieldProps = {
  label: string;
  value: string | React.ReactNode;
  labelColor?: string;
  className?: string;
  valueColor?: string;
  size?: 'default' | 'large';
};

export const InfoField: React.FC<InfoFieldProps> = ({
  label,
  value,
  valueColor = 'text-black',
  className,
  size = 'default',
}) => {
  const labelClass = size === 'large' ? 'text-sm text-gray-600' : 'text-sm font-medium break-words text-[#B2B2B2]';
  const valueClass =
    size === 'large'
      ? `${valueColor} text-xl font-semibold break-words`
      : `${valueColor} text-base font-medium break-words`;
  const gapClass = size === 'large' ? 'gap-1' : 'gap-2';

  return (
    <div className={`flex flex-col justify-start items-start ${gapClass} ${className}`}>
      <div
        className={labelClass}
        style={{
          fontFamily: 'var(--ep-font-avenir)',
        }}
      >
        {label}
      </div>
      <div
        className={valueClass}
        style={{
          fontFamily: 'var(--ep-font-avenir)',
        }}
      >
        {value}
      </div>
    </div>
  );
};
